import { Pipe, PipeTransform, Injectable } from '@angular/core';
import { HTags } from '../datatypes/HTags';

@Pipe({
	name: 'tag'
})
@Injectable({ providedIn: 'root' })
export class TagFilter implements PipeTransform {
	transform(value: HTags): string {
		return HTags.convertToString(value);
	}
}